module.exports = __webpack_public_path__ + "static/23-af3d6a1abc05af2e595c938ec78434e2.jpg";